<template>
  <div class="city-office-select">
    <el-select
      v-model="localBranchId"
      placeholder="Филиал"
      @change="onBranchChange"
      :disabled="disabled"
      popper-class="city-office-select-dropdown"
      style="width: 100%; max-width: 356px;"
    >
      <el-option-group
        v-for="city in cities"
        :key="'city-' + city.id"
        :label="city.name"
      >
        <el-option
          v-for="office in city.children || []"
          :key="'office-' + office.id"
          :label="office.name"
          :value="office.id"
        />
      </el-option-group>
    </el-select>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'CityOfficeSelect',
  props: {
    modelValue: {
      type: [Number, String],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localBranchId: this.modelValue
    }
  },
  computed: {
    ...mapState('cities', ['cities'])
  },
  watch: {
    modelValue(newVal) {
      if (newVal !== this.localBranchId) {
        this.localBranchId = newVal
      }
    },
    cities: {
      immediate: true,
      handler(citiesList) {
        if (this.localBranchId) return
        for (const city of citiesList || []) {
          if (Array.isArray(city.children) && city.children.length > 0) {
            this.localBranchId = city.children[0].id
            this.$emit('update:modelValue', this.localBranchId)
            break
          }
        }
      }
    }
  },
  methods: {
    onBranchChange(newId) {
      this.$emit('update:modelValue', newId)
    }
  }
}
</script>

<style scoped>
.city-office-select {
  width: 100%;
}

.city-office-select :deep(.el-select__placeholder),
.city-office-select :deep(.el-select__selected-item) {
  color: #00c3fe !important;
  -webkit-text-fill-color: #00c3fe !important;
  font-family: var(--ui-font-family-base) !important;
  font-size: 18px !important;
  font-weight: 300 !important;
  line-height: 1 !important;
}

.city-office-select :deep(.el-select__wrapper),
.city-office-select :deep(.el-select__wrapper *) {
  font-family: var(--ui-font-family-base) !important;
  font-weight: 300 !important;
}

.city-office-select :deep(.el-select__caret) {
  color: #00c3fe !important;
  font-weight: 300 !important;
}
</style>

<style>
.city-office-select-dropdown,
.city-office-select-dropdown *,
.city-office-select-dropdown .el-select-group__title,
.city-office-select-dropdown .el-select-dropdown__item,
.city-office-select-dropdown .el-select-dropdown__item span {
  font-family: var(--ui-font-family-base) !important;
  font-weight: 300 !important;
}

.city-office-select-dropdown .el-select-group__title {
  color: #ffffff !important;
  opacity: 0.72;
}

.city-office-select-dropdown .el-select-dropdown__item {
  color: #d7e7ff !important;
}

.city-office-select-dropdown .el-select-dropdown__item.is-selected {
  color: #00c3fe !important;
}
</style>

